var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-flex align-center"},[_c('span',{staticClass:"SlcViewOptionTabs-label mr-2"},[_vm._v(_vm._s(_vm.$t("View"))+":")]),_c('ui-button-group',{attrs:{"role":"navigation"}},_vm._l((_vm.viewOptions),function(ref,index){
var value = ref.value;
var to = ref.to;
var text = ref.text;
return _c('ui-button',{key:("view-" + index),staticClass:"SlcViewOptionTabs-tab",class:{
        'border-blue hover:border-blue-dark': value === _vm.view,
        'bg-gray-100': value !== _vm.view
      },attrs:{"size":"small","color":value === _vm.view ? 'blue' : 'grey',"text-classes":value === _vm.view ? '' : 'text-gray-800 hover:text-gray-900',"to":to},nativeOn:{"click":function($event){return _vm.useMatomoEvent({
          category: 'View Selection new',
          name: ("Click '" + text + "' in View Selection"),
          action: ("Click '" + text + "' in View Selection")
        })}}},[_vm._v("\n      "+_vm._s(_vm.$t(text))+"\n    ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }